import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

const BlogArticle = ({ image, text, author, details }) => (
  <div className="blog-article">
    <div
      className="blog-article__image"
      style={{ backgroundImage: `url(${image})` }}
      title={author}
    />
    <article className="blog-article__content">
      <p className="blog-article__text">{text}</p>
      <div className="blog-article__author">
        <p className="blog-article__author__name">{author}</p>
        <p className="blog-article__author__details">{details}</p>
      </div>
    </article>
  </div>
)

export default BlogArticle

BlogArticle.propTypes = {
  image: PropTypes.string.isRequired,
  details: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
}
